export default {
  claims: [],
  isLoggedIn: false,
  roles: [],
  userId: undefined,
  username: undefined,
  provider: 'app',
};
